import { useContext } from 'react';

import { CourseContext } from '../context/CourseProvider';

export function useCourseDetailCourse() {
  const ctx = useContext(CourseContext);

  if (!ctx) {
    throw new Error(
      'useCourseDetailCourse must be used within a CourseProvider',
    );
  }

  return ctx;
}

export default useCourseDetailCourse;
